// import { Map } from 'immutable'
import { Record } from '../transit'

const Exam = Record({
  id: 0,
  lessons: {},
  finished: false,
  test: null,
  points: 0,
  maxPoints: 0,
}, 'test')

export default Exam



// WEBPACK FOOTER //
// ./src/common/tests/Exam.js